<template>
	<div class="login">
		<header class="login-header">
		<logo class="login-logo" />
		<h4>Check & Train</h4>
		</header>
		<div class="login-content">
			<h2 class="login-content-title">Sign In</h2>
			<form class="login-form">
				<label for="email">
					<input type="email" id="email" placeholder="Email" v-model="userInfo.email">
				</label>
				<label for="password">
					<input type="password" id="password" placeholder="Password" v-model="userInfo.password">
				</label>
				<input type="submit" value="Sign In" @click.prevent="loginUser">
			</form>
			<div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
		</div>
	</div>
</template>

<script>
import Logo from "@/components/icons/Logo.vue";

export default {
	name: "Login",
	components: {
		Logo,
	},
	data() {
		return {
			userInfo: {
				email: '',
				password: ''
			},
			errorMessage: ''
		}
	},
	methods: {
		loginUser: function () {
			if (!this.userInfo.email || !this.userInfo.password) {
				this.errorMessage = 'Please Fill All required fields'
			} else if (this.userInfo.password.length < 3) {
				this.errorMessage = 'Password should contain at least 4 characters'
			} else {
				this.$store.dispatch('loginUser', this.userInfo)
					.then(res => {
						this.errorMessage = res
					})
			}
		}
	}
}
</script>

<style scoped lang="scss">
.error-message {
	color: red;
	text-align: center;
}

.login-title {
	padding: 25px 0;
	margin: 0;
	text-align: center;
}

.login-form {
	max-width: 400px;
	margin: 0 auto;
	padding: 0 15px;
}

.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.login-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  h4 {
	margin-top: 0;
	margin-bottom: 45px;
	font-weight: 400;
	font-size: 18px;
  }
}

.login-content-title {
  margin-bottom: 1.25em;
  text-align: center;
}

.login-content {
  padding-top: 50px;
  padding-bottom: 50px;
  padding-left: 50px;
  padding-right: 50px;
  background: #ffffff;
  box-shadow: 0 22px 34px rgba(174, 181, 190, 0.0936954);
  border-radius: 12px;
  width: 483px;
  height: auto;
}

.login-form-text-field {
  margin-bottom: 1.25em;
}

.login-logo {
  margin-bottom: 1em;
}

input[type="submit"] {
	background-color: #08ce97;
	color: white;
}

h2, h4 {
	font-weight: 700;
}

.error-message {
	margin-top: 10px;
}
</style>
